import React from 'react'
import { Message } from './styles'
import { message } from '~/services'

export const SelectPregnancyMessage = (): JSX.Element => <Message>{message('maternalInfant.select_pregnancy')}</Message>
